import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {User} from '@mintdata-wsp/common/state/DataState';
import {PopupAnchor, SourceAnchor} from '@mintdata-wsp/mint-kit/impl/components/popover/PopupTypes';
import {Tooltip} from '@mintdata-wsp/mint-kit/impl/components/tooltip/Tooltip';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./ProfilePopupCard.less');
const cx = classnames.bind(styles);

export interface ProfilePopupCardProps
{
    user:User;
}

@observer
export class ProfilePopupCard extends React.Component<ProfilePopupCardProps, any>
{
    constructor(props:any)
    {
        super(props);
    }

    @bind
    _onLogout(e:any)
    {
        controllers.user.logout();
    }

    @bind
    _onEditProfile(e:any)
    {
        controllers.ui.dialogs.showDialog(Dialogs.EditProfile, false);
    }

    render()
    {
        let {user} = this.props;

        return (
            <Column className={cx('cardContainer')}>
                <Row className={cx('profilePopupCard')}>
                    <Column className={cx('nameInitialsColumn')}>
                        {user.avatarUrl
                            ? <img src={user.avatarUrl} className={cx('avatar')}/>
                            : User.initials(user)}
                    </Column>

                    <Column className={cx('contentColumn')}>
                        <Row className={cx('fullNameRow')}>
                            {user.fullName}
                        </Row>

                        <Row className={cx('email')}>
                            {user.email}
                        </Row>

                        <Row className={cx('buttonsRow')}>
                            {/*<Icon name={Icons.Exit} className={cx('logoutButtonIcon')} />*/}
                            <WSPButton className={cx('button', 'editProfileButton') }
                                       style={ButtonStyle.SimpleSecondary}
                                       caption={'My Profile'}
                                       onClick={this._onEditProfile}/>
                        <Tooltip
                            tooltipClassName={cx('tooltip')}
                            showArrow={false}
                            closeOnTargetClick={true}
                            content={'Logout'}
                            popoverProps={{
                                className: cx('tooltipPopover'),
                                sourceAnchor: SourceAnchor.CenterBottom,
                                popupAnchor: PopupAnchor.CenterTop,
                                ignoreEsc: true
                            }}
                            hoverOpenDelay={500}
                        >
                            <WSPButton className={cx('logoutButton') }
                                       style={ButtonStyle.SimpleSecondary}
                                       icon={MDIcons.common.Exit}
                                       onClick={this._onLogout}/>
                        </Tooltip>
                        </Row>
                    </Column>
                </Row>
            </Column>
        );
    }
}
